import { render } from "./TvmAutoCompleteAddress.vue?vue&type=template&id=1b7d3aec&scoped=true"
import script from "./TvmAutoCompleteAddress.js?vue&type=script&lang=js&external"
export * from "./TvmAutoCompleteAddress.js?vue&type=script&lang=js&external"

import "./TvmAutoCompleteAddress.vue?vue&type=style&index=0&id=1b7d3aec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7d3aec"],['__file',"src/components/ChatWidget/TvmAutoCompleteAddress/TvmAutoCompleteAddress.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b7d3aec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b7d3aec', __exports__)) {
    api.reload('1b7d3aec', __exports__)
  }
  
  module.hot.accept("./TvmAutoCompleteAddress.vue?vue&type=template&id=1b7d3aec&scoped=true", () => {
    api.rerender('1b7d3aec', render)
  })

}


export default __exports__